import React, { forwardRef } from "react"
import { cn } from "~/lib/utils"

const Dialog = forwardRef<
  HTMLDialogElement,
  React.DialogHTMLAttributes<HTMLDialogElement> & {
    children: React.ReactNode
    className?: string
  }
>(({ children, className, open, ...props }, ref) => {
  return (
    <dialog
      className={cn("h-dialog modal-dialog", className)}
      open={open}
      ref={ref}
      {...props}
    >
      {children}
    </dialog>
  )
})

Dialog.displayName = "Dialog"

const DialogTitle = ({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}) => {
  return <h2 className={cn("modal-title", className)}>{children}</h2>
}

const DialogContent = ({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}) => {
  return <div className={cn("modal-content", className)}>{children}</div>
}

const DialogHeader = ({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}) => {
  return <div className={cn("modal-header", className)}>{children}</div>
}

const DialogCloseButton = ({
  className,
  ...props
}: React.ButtonHTMLAttributes<HTMLButtonElement> & {
  className?: string
}) => {
  return (
    <button className={cn("modal-close", className)} {...props}>
      <span>&times;</span>
    </button>
  )
}

const DialogBody = ({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}) => {
  return <div className={cn("modal-body", className)}>{children}</div>
}

const DialogFooter = ({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}) => {
  return <div className={cn("modal-footer", className)}>{children}</div>
}

export {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogHeader,
  DialogCloseButton,
  DialogBody,
  DialogFooter,
}
